<template>
  <div class="product-reviews-widget">
    <div style="clear: both" />
    <div
      id="judgeme_product_reviews"
      class="jdgm-widget jdgm-review-widget"
      :data-product-title="productTitle"
      :data-id="productId"
      data-auto-install="false"
      v-html="widgetHtml"
    />
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useProductStore } from '../../pinia/ProductStore'

export default {
  name: 'ProductJudgemeReviews',

  computed: {
    ...mapState(useProductStore, [
      'product',
      'combinedListingsProduct',
      'isCombinedListingsProduct'
    ]),

    currentProduct() {
      return this.isCombinedListingsProduct
        ? this.combinedListingsProduct
        : this.product
    },

    productId() {
      return this.currentProduct?.id
    },

    productTitle() {
      return this.currentProduct?.title || ''
    },

    widgetHtml() {
      return this.currentProduct?.metafields?.judgeme?.widget || ''
    }
  },

  watch: {
    productId() {
      this.$nextTick(() => this.initWidget())
    }
  },

  mounted() {
    this.$nextTick(() => this.initWidget())
  },

  methods: {
    initWidget() {
      setTimeout(() => {
        window.jdgm?.customizeBadges?.()
      }, 300)
    }
  }
}
</script>
